// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"45":"357d9c3c","53":"b1da98b9","556":"32dd1bed","673":"b183904a","691":"4240cab0","744":"e6dcd41d","963":"77954175","972":"c843bf91"}[chunkId] + ".chunk.js";
};